export type Session = {
    name: string;
    display: string;
};

export enum TimeoutResponse {
    Stay = 'Stay',
    Logout = 'Logout',
}
